import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { Tax } from '../../interfaces/Tax/Tax';
import { paginateRows } from '../../utils/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<Tax>[] = [
  {
    id: 'id',
    name: 'ID',
    accessor: (row) => <TextColumn value={row.id.toString()} />,
  },
  {
    id: 'title',
    name: 'İsim',
    accessor: (row) => <TextColumn value={row.title} />,
  },
  {
    id: 'multiplier',
    name: 'Oran',
    accessor: (row) => <TextColumn value={`%${row.multiplier.toFixed(2)}`} />,
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type TaxesTableProps = {
  taxes: Tax[];
};

export const TaxesTable = (props: TaxesTableProps) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const paginatedRows = useMemo(
    () => paginateRows(props.taxes, limit, page),
    [props.taxes, limit, page],
  );

  return (
    <DataTable
      columns={columns}
      totalCount={props.taxes.length}
      rows={paginatedRows}
      limit={limit}
      setLimit={setLimit}
      page={page}
      setPage={setPage}
      onClick={(tax) => navigate(`/products/taxes/${tax.id}`)}
    />
  );
};
